import * as React from 'react';

interface OwnProps {
    condition: boolean;
}

export class If extends React.Component<OwnProps> {
    public render() {
        return this.props.condition ? this.props.children : null;
    }
}
